import { render, staticRenderFns } from "./PropertyForm.vue?vue&type=template&id=068e8153&scoped=true"
import script from "./PropertyForm.vue?vue&type=script&lang=js"
export * from "./PropertyForm.vue?vue&type=script&lang=js"
import style0 from "./PropertyForm.vue?vue&type=style&index=0&id=068e8153&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e8153",
  null
  
)

export default component.exports